
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://seyqlxkrcetxmlgdwrde.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNleXFseGtyY2V0eG1sZ2R3cmRlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE4ODE4MzQsImV4cCI6MjA1NzQ1NzgzNH0.alSPEMDSbcx5gPIZlQOFfihqU9bdZlPIU1HGHMt1ifU';

/**
 * Supabase client instance used throughout the application.
 * 
 * Import the supabase client like this:
 * import { supabase } from "@/integrations/supabase/client";
 * 
 * Note: When querying for a single row, use .maybeSingle() instead of .single()
 * to avoid errors when no rows are found.
 */
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
